/* Product navigation follows the shopper's actual collection trail. */
(() => {
  'use strict';
  if (!document.body.classList.contains('template-product')) return;
  let trail;
  try { trail = JSON.parse(sessionStorage.getItem('locab:collection-trail') || 'null'); } catch (_) { return; }
  const back = document.querySelector('[data-locab-history-back]');
  const next = document.querySelector('[data-locab-next-product]');
  if (back) back.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      const referrer = new URL(document.referrer);
      if (referrer.origin === location.origin && /^\/(?:collections\/[^/]+(?:\/products\/[^/]+)?|products\/[^/]+)\/?$/.test(referrer.pathname) && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    } catch (_) { /* Use the collection link as a fallback. */ }
  });
  if (!next || !trail || Date.now() - trail.at > 7200000 || !Array.isArray(trail.products) || !location.pathname.startsWith(trail.collection + '/products/')) return;
  const index = trail.products.findIndex(item => location.pathname.endsWith('/products/' + item.handle));
  if (index < 0 || trail.products.length < 2) return;
  const current = trail.products[index];
  for (let offset = 1; offset < trail.products.length; offset++) {
    const item = trail.products[(index + offset) % trail.products.length];
    if (item.type !== current.type) {
      next.href = trail.collection + '/products/' + encodeURIComponent(item.handle);
      next.hidden = false;
      break;
    }
  }
})();
